<template>
  <main id="content">
    <b-container class="p-4" fluid>
      <b-row>
        <b-col md="2">
          <DashboardNav />
        </b-col>
        <b-col md="10">
          <div class="card card-body" data-aos="fade-down-left">
            <h2 class="h4 mb-3">My Jobs</h2>
            <div
              v-if="loadingJobs"
              class="d-flex justify-content-center pt-5 pb-5 text-muted"
            >
              <font-awesome-icon icon="sync" size="2x" spin />
            </div>
            <div v-else-if="jobs.length > 0">
              <div
                class="col-md-6 col-lg-4 col-xs-12"
                v-for="job in jobs"
                :key="job['.key']"
                style="display: inline-block;"
                data-aos="fade-right"
                data-aos-easing="linear"
              >
                <router-link :to="'/settings/job/' + s_id + '/' + job['.key']">
                  <div class="card" style="margin-top:10px;">
                    <img
                      class="card-img-top"
                      src="../assets/card_background.png"
                    />
                    <!-- Text Overlay -->
                    <div class="card-img-overlay" style="margin-left:8px;">
                      <div class="card-title text_ui_title">
                        {{ job.jobTitle }}
                      </div>
                      <div class="text_ui_date">
                        {{
                          new Date(
                            job.jobCreationTime * 1000
                          ).toLocaleDateString("en-us", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit"
                          })
                        }}
                      </div>
                    </div>
                    <div class="card-body" style="padding-top:0px;">
                      <div class="card-text row" style="margin-left:5px;">
                        <div style="width:65%">
                          <span style="color:#818181; font-size:11px;"
                            >Created by</span
                          >
                          <br />
                          <span class="text_ui">
                            <span v-if="users[job.uid]">
                              {{ get_username(job.uid) }} <br />
                              {{ get_emailid(job.uid) }}
                            </span>
                            <span v-else>
                              Demo
                            </span>
                          </span>
                        </div>
                        <div
                          style="text-align:right; font-size:13px; margin-right:2px; font-weight:bold; width:30%; color:#000;"
                        >
                          <span class="text_ui"
                            >Completed: <br />
                            <span class="text-success">
                              {{ check_completed_job(job) }}
                            </span>
                          </span>
                          <br />
                          <span class="text_ui"
                            >Pending: <br />
                            <span class="text-danger">
                              {{ check_pending_job(job) }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div v-else class="text-center pt-4 pb-3 text-muted">
              <div class="d-flex justify-content-center mb-3">
                <font-awesome-icon icon="exclamation-triangle" size="3x" />
              </div>
              <div class="h5">
                {{ loadingError ? "Error loading jobs" : "You have no jobs" }}
              </div>
              <p style="text-align:center;opacity:0.5;">
                {{
                  loadingError ? "" : "Please use the app to upload any jobs"
                }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>
<script>
import DashboardNav from "../components/DashboardNav.vue";
import { db } from "../modules/database";
import { mapGetters } from "vuex";
// import firebase from "firebase/app";

export default {
  data() {
    return {
      sr: 0,
      loadingJobs: false,
      loadingError: false,
      jobs: [],
      s_id: "",
      dataofuser: "",
      users: {}
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.setupFirebaseReading();
    this.updateSubscriptionid();
    // this.getUsername("t8HUDUGfYCP85Lz9Ku1KB8JSP3Y2");
  },
  methods: {
    get_username(u_id) {
      let full_name = "Demo";
      if (u_id != null) {
        if (typeof this.users[u_id] != "undefined") {
          full_name = this.users[u_id].UserFullName;
        }
        // full_name = this.users.u_id.UserFullName;
      }
      return full_name;
    },
    get_emailid(u_id) {
      let email_id = "";
      if (u_id != null) {
        if (typeof this.users[u_id] != "undefined") {
          email_id = this.users[u_id].Email;
        }
      }
      return email_id;
    },
    serialnumber() {
      return 1;
    },
    check_completed_job(job) {
      let drills = job.drills;
      let count = 0;
      if (
        typeof drills !== "undefined" &&
        typeof Object.keys(drills) !== "undefined" &&
        Object.keys(drills).length > 0
      ) {
        // if (typeof drills == "undefined") {
        for (const drillKey of Object.keys(drills)) {
          // console.log(drills[drillKey].status);
          if (drills[drillKey].status == true) {
            count += 1;
          }
        }
      } else {
        console.log("fail");
      }
      return count;
    },
    check_pending_job(job) {
      let drills = job.drills;
      let count = 0;
      if (
        typeof drills !== "undefined" &&
        typeof Object.keys(drills) !== "undefined" &&
        Object.keys(drills).length > 0
      ) {
        // if (typeof drills == "undefined") {
        for (const drillKey of Object.keys(drills)) {
          // console.log(drills[drillKey].status);
          if (drills[drillKey].status == false) {
            count += 1;
          }
        }
      } else {
        console.log("fail");
      }
      return count;
    },
    updateSubscriptionid() {
      this.s_id = this.$route.params.id;
    },
    // getUsername(userId) {
    //   var id=userId;
    //   this.users."/"+id+.Email;
    // },
    setupFirebaseReading() {
      this.loadingJobs = true;
      this.$rtdbBind(
        "jobs",
        db.ref("jobs/" + this.$route.params.id)
        // .orderByChild("uid")
        // .equalTo(this.$route.params.id)
      );
      this.$rtdbBind("users", db.ref("users"))
        .catch(error => {
          console.log(error);
          this.loadingError = true;
        })
        .finally(() => {
          this.loadingJobs = false;
        });
    }
  },
  components: {
    DashboardNav
  }
};
</script>
<style>
a:hover {
  text-decoration: none;
}
.text_ui {
  color: #212529;
  font-size: 14px;
  font-weight: bold;
}
.text_ui_date {
  color: #fff;
  font-size: 14px;
}
.text_ui_title {
  color: #fff;
  font-size: 22px;
  font-weight: bold;
}
@media (max-width: 1200px) and (min-width: 765px) {
  .text_ui {
    font-size: 10px !important;
  }
  .text_ui_date {
    font-size: 10px;
  }
  .text_ui_title {
    font-size: 16px;
  }
}
</style>
